import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { parceriasApi } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { toast } from 'sonner';
import { Building2, Wrench, CheckCircle2, Loader2, ArrowLeft, CreditCard, LayoutDashboard, Receipt, ShieldCheck } from 'lucide-react';

const TIPOS_EMPRESA = ['Imobiliária', 'Condomínio', 'Administradora de Imóveis', 'Administradora de Condomínio', 'Corretor', 'Síndico', 'Construtora', 'Empresa', 'Outro'];

const BENEFICIOS = [
  { icon: LayoutDashboard, titulo: 'Portal exclusivo', texto: 'Abra solicitações, acompanhe cada serviço e veja suas faturas em um só lugar.' },
  { icon: CreditCard, titulo: 'Limite de crédito', texto: 'Serviços executados primeiro, pagamento depois — com faturamento semanal ou mensal.' },
  { icon: Receipt, titulo: 'Preço fechado', texto: 'Valores definidos antes da execução. Sem surpresa no final.' },
  { icon: ShieldCheck, titulo: 'Equipe qualificada', texto: 'Profissionais verificados e garantia em todos os serviços.' },
];

export default function SejaParceiro() {
  const [tipoCadastro, setTipoCadastro] = useState('parceiro');
  const [enviado, setEnviado] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [form, setForm] = useState({ nome: '', telefone: '', cidade: '', email: '', tipo_empresa: '', razao_social: '', cnpj: '', observacoes: '' });

  const set = (k) => (e) => setForm({ ...form, [k]: e.target ? e.target.value : e });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nome.trim() || !form.telefone.trim()) {
      toast.error('Informe seu nome e telefone');
      return;
    }
    if (tipoCadastro === 'parceiro' && !form.tipo_empresa) {
      toast.error('Selecione o tipo de empresa');
      return;
    }
    setEnviando(true);
    try {
      await parceriasApi.criar({ ...form, tipo_cadastro: tipoCadastro });
      setEnviado(true);
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Não foi possível enviar. Tente novamente.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F6F8F7]">
      <header className="bg-white border-b border-gray-100">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 h-20 flex items-center justify-between">
          <Link to="/"><img src="/logo-header.png" alt="Tenance" className="h-20" /></Link>
          <Link to="/" className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-[#2B7A3D] font-medium">
            <ArrowLeft size={15} /> Voltar ao site
          </Link>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
        {enviado ? (
          <div className="max-w-md mx-auto bg-white rounded-2xl border border-gray-200 p-8 text-center" data-testid="parceria-sucesso">
            <CheckCircle2 size={52} className="mx-auto text-[#2B7A3D] mb-4" />
            <h1 className="text-2xl font-bold text-[#3D4F5F] mb-2" style={{ fontFamily: 'Work Sans' }}>Solicitação enviada!</h1>
            <p className="text-gray-500 text-sm mb-6">
              Recebemos seu interesse em {tipoCadastro === 'parceiro' ? 'ser parceiro' : 'prestar serviços para'} a Tenance.
              Nossa equipe vai analisar e entrar em contato pelo seu WhatsApp em breve.
            </p>
            <Link to="/"><Button className="bg-[#2B7A3D] hover:bg-[#236632]">Voltar ao site</Button></Link>
          </div>
        ) : (
          <div className="grid lg:grid-cols-2 gap-10">
            <div>
              <h1 className="text-4xl sm:text-5xl font-bold text-[#3D4F5F] mb-4" style={{ fontFamily: 'Work Sans' }}>
                Cresça com a <span className="text-[#2B7A3D]">Tenance</span>
              </h1>
              <p className="text-gray-600 mb-8">
                Imobiliárias, administradoras, condomínios, síndicos e corretores contam com a Tenance para cuidar da
                manutenção dos seus imóveis. E se você é prestador de serviço, venha trabalhar com a gente.
              </p>
              <div className="space-y-4">
                {BENEFICIOS.map((b) => (
                  <div key={b.titulo} className="flex gap-3 items-start bg-white rounded-xl border border-gray-100 p-4">
                    <div className="w-10 h-10 rounded-lg bg-[#2B7A3D]/10 flex items-center justify-center shrink-0">
                      <b.icon size={19} className="text-[#2B7A3D]" />
                    </div>
                    <div>
                      <div className="font-semibold text-[#3D4F5F] text-sm">{b.titulo}</div>
                      <div className="text-xs text-gray-500 mt-0.5">{b.texto}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-2xl border border-gray-200 p-6 sm:p-8 h-fit">
              <div className="grid grid-cols-2 gap-2 mb-6">
                <button type="button" onClick={() => setTipoCadastro('parceiro')} data-testid="opcao-parceiro"
                  className={`flex flex-col items-center gap-1.5 rounded-xl border-2 p-4 text-sm font-semibold transition-colors ${tipoCadastro === 'parceiro' ? 'border-[#2B7A3D] bg-[#2B7A3D]/5 text-[#2B7A3D]' : 'border-gray-200 text-gray-500 hover:border-gray-300'}`}>
                  <Building2 size={22} /> Sou empresa
                  <span className="text-[10px] font-normal text-gray-400">imobiliária, condomínio, corretor...</span>
                </button>
                <button type="button" onClick={() => setTipoCadastro('prestador')} data-testid="opcao-prestador"
                  className={`flex flex-col items-center gap-1.5 rounded-xl border-2 p-4 text-sm font-semibold transition-colors ${tipoCadastro === 'prestador' ? 'border-[#2B7A3D] bg-[#2B7A3D]/5 text-[#2B7A3D]' : 'border-gray-200 text-gray-500 hover:border-gray-300'}`}>
                  <Wrench size={22} /> Sou prestador
                  <span className="text-[10px] font-normal text-gray-400">quero prestar serviços</span>
                </button>
              </div>

              <form onSubmit={handleSubmit} className="space-y-4">
                {tipoCadastro === 'parceiro' && (
                  <>
                    <div className="space-y-1">
                      <Label>Tipo de empresa *</Label>
                      <Select value={form.tipo_empresa || undefined} onValueChange={(v) => setForm({ ...form, tipo_empresa: v })}>
                        <SelectTrigger data-testid="parceria-tipo-empresa"><SelectValue placeholder="Selecione" /></SelectTrigger>
                        <SelectContent>
                          {TIPOS_EMPRESA.map((t) => (<SelectItem key={t} value={t}>{t}</SelectItem>))}
                        </SelectContent>
                      </Select>
                    </div>
                    <div className="space-y-1">
                      <Label>Nome da empresa</Label>
                      <Input value={form.razao_social} onChange={set('razao_social')} placeholder="Razão social ou nome fantasia" data-testid="parceria-razao-social" />
                    </div>
                  </>
                )}
                <div className="grid sm:grid-cols-2 gap-3">
                  <div className="space-y-1">
                    <Label>{tipoCadastro === 'parceiro' ? 'Nome do responsável *' : 'Seu nome *'}</Label>
                    <Input value={form.nome} onChange={set('nome')} required data-testid="parceria-nome" />
                  </div>
                  <div className="space-y-1">
                    <Label>WhatsApp *</Label>
                    <Input value={form.telefone} onChange={set('telefone')} placeholder="(31) 99999-9999" required data-testid="parceria-telefone" />
                  </div>
                </div>
                <div className="grid sm:grid-cols-2 gap-3">
                  <div className="space-y-1">
                    <Label>{tipoCadastro === 'prestador' ? 'Cidade onde atende' : 'Cidade'}</Label>
                    <Input value={form.cidade} onChange={set('cidade')} placeholder="Ex.: Belo Horizonte" data-testid="parceria-cidade" />
                  </div>
                  {tipoCadastro === 'parceiro' ? (
                    <div className="space-y-1">
                      <Label>CNPJ (opcional)</Label>
                      <Input value={form.cnpj} onChange={set('cnpj')} data-testid="parceria-cnpj" />
                    </div>
                  ) : (
                    <div className="space-y-1">
                      <Label>E-mail (opcional)</Label>
                      <Input type="email" value={form.email} onChange={set('email')} data-testid="parceria-email" />
                    </div>
                  )}
                </div>
                {tipoCadastro === 'parceiro' && (
                  <>
                    <div className="space-y-1">
                      <Label>E-mail (opcional)</Label>
                      <Input type="email" value={form.email} onChange={set('email')} data-testid="parceria-email-emp" />
                    </div>
                    <div className="space-y-1">
                      <Label>Conte um pouco sobre a empresa</Label>
                      <Textarea rows={2} value={form.observacoes} onChange={set('observacoes')} placeholder="Ex.: administramos 120 imóveis em BH" data-testid="parceria-obs" />
                    </div>
                  </>
                )}
                {tipoCadastro === 'prestador' && (
                  <div className="space-y-1">
                    <Label>Quais serviços você faz? (opcional)</Label>
                    <Textarea rows={2} value={form.observacoes} onChange={set('observacoes')} placeholder="Ex.: elétrica, hidráulica, pintura..." data-testid="parceria-obs-prest" />
                  </div>
                )}
                <Button type="submit" disabled={enviando} className="w-full bg-[#2B7A3D] hover:bg-[#236632] h-11" data-testid="parceria-enviar">
                  {enviando ? (<><Loader2 size={16} className="mr-2 animate-spin" /> Enviando...</>) : 'Enviar solicitação'}
                </Button>
                <p className="text-[11px] text-gray-400 text-center">Sem compromisso. Nossa equipe analisa e entra em contato pelo WhatsApp.</p>
              </form>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
